<template>
    <a-modal v-model:visible="loginVisible" :footer="null" :width="690" wrapClassName="login-modal"
        :maskClosable="false" :centered="true" @cancel="modalClose">
        <div class="cus-title">
            <img src="https://static5.yingsaidata.com/mip/img/5528304-login-title.png" />
        </div>
        <div class="wrap">
            <div class="left">
                <h3>验证码登录</h3>
                <a-form :rules="rules" ref="formRef" name="custom-validation" :model="formState">
                    <a-form-item name="mobile" class="ipt">
                        <a-input v-model:value="formState.mobile" @focus="handleFocusMobile" placeholder="请输入手机号"
                            key="mobile" class="login-input">
                        </a-input>
                    </a-form-item>
                    <a-form-item class="psd-wrap ipt" name="code">
                        <a-input class="login-input" @focus="handleFocusCode" v-model:value="formState.code"
                            placeholder="请输入验证码" @on-enter="handleFinish" key="code">
                        </a-input>
                        <span :class="{ 'show-psd': true, code: true, disabled: !isEableSendCode }" @click="() => {
                            handleSendCodeClick(formState.mobile)
                        }
                            " v-if="countDown === 60">
                            获取验证码
                        </span>
                        <span :class="{ 'show-psd': true, code: true }" v-else>
                            {{ countDown }}s
                        </span>
                    </a-form-item>

                    <a-form-item class="login-btn-wrap">
                        <a-button type="primary" size="large" :loading="loginLoading" class="login-btn"
                            :class="{ 'disabled-btn': !isAgreePolicy || !isEableSendCode || !formState.code }"
                            @click="handleFinish">
                            <span class="login-text">立即登录</span></a-button>
                    </a-form-item>
                    <p class="tip">未注册手机号将自动注册</p>
                </a-form>
            </div>
            <div class="right">
                <div class="top">
                    <svg class="iconpark-icon" v-if="!loginSuccess">
                        <use href="#rongqi-dnf9ba7o"></use>
                    </svg>
                    <svg class="iconpark-icon" v-else>
                        <use href="#rongqi-dnf99p8n"></use>
                    </svg>
                    <span>微信扫码登录</span>
                </div>
                <a-spin :spinning="!showQrCode"></a-spin>
                <img :src="qrCode" @load="qrCodeLoad" v-show="showQrCode" />
            </div>
        </div>
        <div class="policy-wrap" @mouseover="isShowTip = false">
            <a-tooltip title="请阅读并勾选协议" :visible="isShowTip" placement="bottom">
                <a-checkbox v-model:checked="isAgreePolicy"></a-checkbox>
            </a-tooltip>
            <span class="read-tips">
                已阅读同意
                <span @click="jump2Policy">《用户使用协议》</span>
                <span @click="jump2Privacy">《营赛隐私协议》</span>
            </span>
        </div>
    </a-modal>
</template>

<script lang="ts" setup>
import { ref, reactive, onUnmounted, watch } from 'vue'
import { accountApi } from '@/api/account/index'
import { message } from 'ant-design-vue'
import { useJump } from './hook'
import { setToken } from '@/utils/token/index'
import { useUserInfoStore } from '@/stores/user-info'

const loginVisible = ref(false)
let qrCode = ref('')
let qrId = ref('')
let showQrCode = ref(false)
const getQrcode = () => {
    showQrCode.value = false
    accountApi.getQrcode({
        path: 'pages/login/login', source_id: 5, "env_version": import.meta.env.VITE_APP_ENV == 'prod' ? "release" : "trial",
        "check_path": false
    }).then((res: any) => {
        qrCode.value = 'data:image/jpeg;base64,' + res.data.url
        qrId.value = res.data.id
    })
}
const qrCodeLoad = () => {
    showQrCode.value = true
}
let loginSuccess = ref(false)
let loginTimer = null
const getLoginStatus = () => {
    accountApi.checkScanLogin({ id: qrId.value }).then((res: any) => {
        if (res.data.status == 2) {
            loginSuccess.value = true
            message.success('登录成功')
            setToken(res.data.token)
            setTimeout(() => {
                userInfoStore.initUserInfo()
            })
            loginVisible.value = false
            clearInterval(loginTimer)
            point(1, 3, { "登录信息": "登录成功" }, '登录弹窗中扫描微信二维码')
            point(1, 2, { "关闭原因": "登录成功自动关闭" }, '登录弹窗关闭即触发')
        } else {
            if (res.message != 'success') point(1, 3, { "登录失败": res.data.message }, '登录弹窗中扫描微信二维码')
        }
    })
}
const showModal = () => {
    point(1, 1, {}, '登录弹窗曝光即触发')
    loginVisible.value = true
    loginSuccess.value = false
    getQrcode()
    loginTimer = setInterval(() => {
        getLoginStatus()
    }, 3000)
}
defineExpose({ showModal })

const userInfoStore = useUserInfoStore()
const formRef = ref()
const validateMobile = async (rule: any, value: string) => {
    if (value === '') {
        return Promise.reject('请输入手机号码')
    }
    if (!/^1[0-9]{10}$/.test(value)) {
        return Promise.reject('请输入正确的手机号码')
    }
    return Promise.resolve()
}
const validateCode = async (rule: any, value: string) => {
    if (value === '') {
        return Promise.reject('请输入验证码')
    }
    if (!/^[0-9]{6}$/.test(value)) {
        return Promise.reject('请输入正确的验证码')
    }
    return Promise.resolve()
}
const rules = {
    mobile: [{ required: true, validator: validateMobile, trigger: 'blur' }],
    code: [{ required: true, validator: validateCode, trigger: 'blur' }]
}
const formState = reactive({
    mobile: '',
    code: ''
})
const LIMIT_TIMEOUT = 60
let timer: any = null
const countDown = ref(60)
// 是否可以发送验证码
const isEableSendCode = ref(false)
const setIsEableSendCode = () => {
    isEableSendCode.value = /^1[0-9]{10}$/.test(formState.mobile)
}

watch(formState, setIsEableSendCode, { deep: true })
//发送验证码
const handleSendCodeClick = (mobile: string) => {
    if (!isEableSendCode.value) return
    countDown.value = countDown.value - 1
    point(1, 2, { '手机号': mobile }, '登录弹窗中点击获取验证码')
    accountApi
        .getCode({ mobile })
        .then(() => {
            timer = setInterval(() => {
                countDown.value = countDown.value - 1
                if (countDown.value < 1) {
                    clearInterval(timer)
                    countDown.value = LIMIT_TIMEOUT
                }
            }, 1000)
        })
        .catch((err) => {
            message.error('发送失败！' + err.data?.message)
            countDown.value = LIMIT_TIMEOUT
        })
}

onUnmounted(() => {
    clearInterval(timer)
    clearInterval(loginTimer)
    loginSuccess.value = false
})
const handleFocusMobile = () => {
    formRef.value.clearValidate(['mobile'])
}
const handleFocusCode = () => {
    formRef.value.clearValidate(['code'])
}
watch(() => loginVisible.value, (val) => {
    if (!val) {
        clearInterval(timer)
        clearInterval(loginTimer)
        loginSuccess.value = false
        formState.mobile = ''
        formState.code = ''
        formRef.value.resetFields()
        countDown.value = LIMIT_TIMEOUT
    }
})
// 勾选提示
const isShowTip = ref(false)
const isAgreePolicy = ref(false)
const loginLoading = ref(false)
const handleFinish = () => {
    let errMsg = ''
    formRef.value.validate().then(async () => {
        if (!isAgreePolicy.value) {
            isShowTip.value = true
            return
        }
        loginLoading.value = true
        try {
            const res = await accountApi.login({
                account: formState.mobile,
                code: formState.code,
                type: 2,
                source_id: 5,
                device: 1
            })
            message.success('登录成功')
            setToken(res.data.token)
            loginLoading.value = false
            setTimeout(() => {
                userInfoStore.initUserInfo()
            })
            loginVisible.value = false
        } catch (err: any) {
            loginLoading.value = false
            errMsg = err.data?.message
        } finally {
            if (errMsg) {
                point(1, 2, { '手机号': formState.mobile, '登录失败': errMsg }, '登录弹窗中点击立即登录')
            } else {
                point(1, 2, { '手机号': formState.mobile, '登录信息': '登录成功' }, '登录弹窗中点击立即登录')
            }
        }
    })
}

const { jump2Policy, jump2Privacy } = useJump()

const modalClose = () => {
    point(1, 2, { "关闭原因": "手动关闭" }, '登录弹窗关闭即触发')
}
</script>

<style lang="less" scoped>
.cus-title {
    width: 100%;
    height: 30px;
    margin-bottom: 20px;

    :deep(img) {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
    }
}

.left {
    width: 410px;
    padding-left: 23px;
    padding-right: 48px;
    border-right: 1px solid #d8d8d8;

    :deep(.ant-input) {
        padding-left: 16px;
    }

    .tip {
        font-size: 12px;
        color: #aaaaaa;
        text-align: center;
        margin-top: 2px;
    }

    h3 {
        color: #3d3d3d;
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 16px;
    }

    .iconpark-icon {
        width: 20px;
        height: 20px;
        color: #999999;
    }

    .login-input {
        height: 48px;
        border-radius: 50px;

        &:focus {
            box-shadow: none !important;
        }
    }

    .psd-wrap {
        position: relative;

        .show-psd {
            z-index: 99;
            position: absolute;
            cursor: pointer;
            right: 16px;
            top: 11px;
            white-space: nowrap;
            color: rgba(0, 0, 0, 0.5);
            font-size: 16px;

            &.code {
                color: #5b25fe;
            }

            &.disabled {
                color: rgba(91, 37, 254, 0.5);
            }
        }
    }

    .login-btn-wrap {
        margin-bottom: 0;
        margin-top: 36px;

        &:hover {
            opacity: 0.5;
        }

        :deep(.ant-form-item-control-input-content) {
            position: relative;

            &:before {
                content: '';
                position: absolute;
                left: 18px;
                top: 7px;
                width: 306px;
                height: 43.2px;
                border-radius: 4px;
                opacity: 1;
                filter: blur(14px);
            }
        }
    }

    .login-btn {
        background: linear-gradient(99deg, #7856f6 14%, #571fff 89%);
        color: #fff;
        height: 48px;
        border: none;
        border-radius: 24px;
        width: 100%;

        .login-text {
            font-size: 16px;
        }

        &.disabled-btn {
            background: linear-gradient(98deg, rgba(120, 86, 246, 0.5) 16%, rgba(87, 31, 255, 0.5) 89%);
        }
    }

    .ipt {
        margin-bottom: 24px;
        height: 48px;

        :deep(.ant-form-item-control-input-content) {
            display: flex;
            flex-direction: row;
            align-items: center;

            p {
                width: 50px;
                color: #556070;
                font-size: 14px;
            }
        }
    }

    :deep(.ant-input) {
        &::placeholder {
            font-size: 16px;
        }
    }
}

.right {
    .top {
        display: flex;
        align-items: center;
        padding-left: 59px;
        margin-bottom: 37px;

        span {
            margin-left: 4px;
            font-size: 18px;
            font-weight: 500;
            color: #3d3d3d;
            position: relative;
            top: -1px;
        }
    }

    :deep(.ant-spin) {
        margin-left: 110px;
    }

    img {
        height: 140px;
        width: 140px;
        margin-left: 56px;
    }
}

.policy-wrap {
    color: rgba(0, 0, 0, 0.4);
    text-align: center;
    margin-top: 28px;

    .read-tips {
        margin-left: 8px;
        color: rgba(0, 0, 0, 0.4);

        span {
            color: #5822fe;
            cursor: pointer;
        }
    }
}
</style>
